import { render } from "./add-vip.vue?vue&type=template&id=2e3bc4b8&scoped=true"
import script from "./add-vip.vue?vue&type=script&lang=js"
export * from "./add-vip.vue?vue&type=script&lang=js"

import "./add-vip.vue?vue&type=style&index=0&id=2e3bc4b8&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3bc4b8"]])

export default __exports__